(ns hai.web-app.platform
  (:require
   [clojure.string :as str]))

(goog-define ORIGIN "")

(defn url [& parts]
  (str
   ORIGIN
   (when (and (first parts) (not= \/ (ffirst parts)))
     "/")
   (str/join "/" parts)))
